"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcCircleLoadingBehavior = void 0;
var default_behavior_1 = require("../../../common/models/default-behavior");
var bc_circle_loading_constants_1 = require("./bc-circle-loading-constants");
var bc_circle_loading_constants_2 = require("./bc-circle-loading-constants");
var bc_circle_loading_constants_3 = require("./bc-circle-loading-constants");
var bc_circle_loading_constants_4 = require("./bc-circle-loading-constants");
var bc_circle_loading_constants_5 = require("./bc-circle-loading-constants");
var bc_circle_loading_constants_6 = require("./bc-circle-loading-constants");
var BcCircleLoadingBehavior = (function (_super) {
    __extends(BcCircleLoadingBehavior, _super);
    function BcCircleLoadingBehavior() {
        var _this = _super.call(this) || this;
        _this.speedLoader = '0.5';
        return _this;
    }
    BcCircleLoadingBehavior.setUpAll = function () {
        var circleLoadingElements = Array.from(document.querySelectorAll(".".concat(bc_circle_loading_constants_1.BC_CIRCLE_LOADING)));
        var elements = [];
        for (var _i = 0, circleLoadingElements_1 = circleLoadingElements; _i < circleLoadingElements_1.length; _i++) {
            var circleLoadingElement = circleLoadingElements_1[_i];
            var element = circleLoadingElement;
            var bcCircleLoadingBehavior = new BcCircleLoadingBehavior();
            bcCircleLoadingBehavior.setElement(element);
            bcCircleLoadingBehavior.setUp();
            elements.push(bcCircleLoadingBehavior);
        }
        return elements;
    };
    BcCircleLoadingBehavior.prototype._setUp = function () {
        this.circleLoadingState = bc_circle_loading_constants_1.HIDDEN_CIRCLE_LOADING;
        this.accessibility();
        this.updateSpeedLoader();
    };
    BcCircleLoadingBehavior.prototype.accessibility = function () {
        this.getAccessibilityLabel();
        this.bcAccessibilityLabel.setAttribute(bc_circle_loading_constants_3.ARIA_LIVE_CIRCLE_LOADING, bc_circle_loading_constants_3.POLITE_CIRCLE_LOADING);
    };
    BcCircleLoadingBehavior.prototype.getAccessibilityLabel = function () {
        this.bcAccessibilityLabel = this.mySelf.querySelector(".".concat(bc_circle_loading_constants_4.BC_CIRCLE_LOADING_ARIA_LABEL));
    };
    BcCircleLoadingBehavior.prototype.updateSpeedLoader = function () {
        this.speedLoader = this.mySelf.getAttribute(bc_circle_loading_constants_6.SPEED_LOADER_LOADING) || this.speedLoader;
        var lodaerIcon = this.mySelf.querySelector(".".concat(bc_circle_loading_constants_6.BC_CIRCLE_LOADING_LOADER_ICON));
        if (lodaerIcon) {
            lodaerIcon.setAttribute(bc_circle_loading_constants_4.STYLE_CIRCLE_LOADING, "".concat(bc_circle_loading_constants_5.ANIMATION_DURATION_CIRCLE_LOADING, ": ").concat(this.speedLoader, "s;"));
        }
    };
    BcCircleLoadingBehavior.prototype.toggleVisibility = function () {
        if (this.circleLoadingState == bc_circle_loading_constants_2.VISIBLE_CIRCLE_LOADING) {
            this.mySelf.classList.add(bc_circle_loading_constants_2.BC_CIRCLE_LOADING_ACTIVE);
        }
        else {
            this.mySelf.classList.remove(bc_circle_loading_constants_2.BC_CIRCLE_LOADING_ACTIVE);
        }
    };
    BcCircleLoadingBehavior.prototype.showCircleLoading = function () {
        this.circleLoadingState = bc_circle_loading_constants_2.VISIBLE_CIRCLE_LOADING;
        this.toggleVisibility();
    };
    BcCircleLoadingBehavior.prototype.hideCircleLoading = function () {
        this.circleLoadingState = bc_circle_loading_constants_1.HIDDEN_CIRCLE_LOADING;
        this.toggleVisibility();
    };
    return BcCircleLoadingBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcCircleLoadingBehavior = BcCircleLoadingBehavior;
